import React from 'react';

interface GlassToggleProps {
  isActive: boolean;
  onToggle: (value: boolean) => void;
  isDarkMode?: boolean;
  label?: string;
  className?: string;
}

export const GlassToggle: React.FC<GlassToggleProps> = ({
  isActive,
  onToggle,
  isDarkMode = false,
  label,
  className = ''
}) => {
  return (
    <div className={`glass-toggle-wrapper inline-block ${className}`} aria-label={label || 'Toggle'}>
      <label className="switch select-none" aria-pressed={isActive}>
        <input
          type="checkbox"
          checked={isActive}
          onChange={(e) => onToggle(e.target.checked)}
          aria-label={label || 'Toggle'}
        />
        <span className="slider" />
      </label>
      <style>{`
        .glass-toggle-wrapper .switch {
          --button-width: 3.3em;
          --button-height: 1.7em;
          --toggle-diameter: 1.4em;
          --button-toggle-offset: calc((var(--button-height) - var(--toggle-diameter)) / 2);
          --toggle-shadow-offset: 10px;
          --toggle-wider: 3em;
          --color-grey: #cccccc;
          --color-green: #4296f4;
          display: inline-block;
        }

        .glass-toggle-wrapper .slider {
          display: inline-block;
          width: var(--button-width);
          height: var(--button-height);
          background-color: var(--color-grey);
          border-radius: calc(var(--button-height) / 2);
          position: relative;
          transition: 0.3s all ease-in-out;
        }

        .glass-toggle-wrapper .slider::after {
          content: "";
          display: inline-block;
          width: var(--toggle-diameter);
          height: var(--toggle-diameter);
          background-color: #fff;
          border-radius: calc(var(--toggle-diameter) / 2);
          position: absolute;
          top: var(--button-toggle-offset);
          transform: translateX(var(--button-toggle-offset));
          box-shadow: var(--toggle-shadow-offset) 0 calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);
          transition: 0.3s all ease-in-out;
        }

        .glass-toggle-wrapper .switch input[type="checkbox"]:checked + .slider {
          background-color: var(--color-green);
        }

        .glass-toggle-wrapper .switch input[type="checkbox"]:checked + .slider::after {
          transform: translateX(calc(var(--button-width) - var(--toggle-diameter) - var(--button-toggle-offset)));
          box-shadow: calc(var(--toggle-shadow-offset) * -1) 0 calc(var(--toggle-shadow-offset) * 4) rgba(0, 0, 0, 0.1);
        }

        .glass-toggle-wrapper .switch input[type="checkbox"] {
          display: none;
        }

        .glass-toggle-wrapper .switch input[type="checkbox"]:active + .slider::after {
          width: var(--toggle-wider);
        }

        .glass-toggle-wrapper .switch input[type="checkbox"]:checked:active + .slider::after {
          transform: translateX(calc(var(--button-width) - var(--toggle-wider) - var(--button-toggle-offset)));
        }
      `}</style>
    </div>
  );
};
